import request from "@/utils/request";

export default function agentGetZhifubaoUserByPhone(params) {
    return request({
        url: `/user/zhifubaoUser/agentGetZhifubaoUserByPhone`,
        params: params
    })
}
